import defaultState from './defaultState'
import mutations from './mutations'

export default {
  namespaced: true,
  state: defaultState(),
  mutations,
}
